module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "width": "100%",
      "border-top": "solid 3px grey"
    }
  }, _vm._l((_vm.item), function(property, heading, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "object-viewer-cell object-viewer-heading"
    }, [_vm._v("\n            " + _vm._s(heading) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "object-viewer-cell"
    }, [_vm._v("\n            " + _vm._s(property) + "\n        ")])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98b28b60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ObjectViewer.vue
// module id = 2631
// module chunks = 1